module.exports = __webpack_public_path__ + "static/media/Q7.405bb9d6.jpg";